import React from 'react'
import ProductCheckInTypeItem from './ProductCheckInTypeItem'
import SearchField from './SearchField'

export default ({
  products = [],
  onProductSelect,
  filterText,
  onFilterTextChange,
}) => (
  <div className="flex flex-col h-full">
    <div className="mb-4">
      <SearchField
        value={filterText}
        onChange={onFilterTextChange}
        placeholder="Search products..."
      />
    </div>
    <div className="flex-1 overflow-y-auto">
      {renderProductItems(products, onProductSelect)}
    </div>
  </div>
)

const renderProductItems = (products, onProductSelect) => {
  if (products.length <= 0)
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <svg
          className="w-16 h-16 text-gray-300 mb-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
          />
        </svg>
        <h3 className="text-gray-900 font-medium text-lg mb-1">
          No products found
        </h3>
        <p className="text-gray-500 text-sm">
          Try adjusting your search criteria
        </p>
      </div>
    )
  return products.map((product) => (
    <ProductCheckInTypeItem
      key={product._id}
      product={product}
      onClick={onProductSelect}
    />
  ))
}
